var map = {
	"./iBucks.png": "f7fe",
	"./iBulls.png": "9db2",
	"./iCavs.png": "f70b",
	"./iCeltics.png": "57de",
	"./iClippers.png": "c7da",
	"./iGrizzles.png": "672b",
	"./iHawks.png": "82ff",
	"./iHeat.png": "3329",
	"./iHornets.png": "4c17",
	"./iJazz.png": "9f25",
	"./iKings.png": "f1b4",
	"./iKnicks.png": "d075",
	"./iLakers.png": "ce73",
	"./iMagic.png": "1378",
	"./iMavericks.png": "24fa",
	"./iNets.png": "4fcd",
	"./iNuggets.png": "07cb",
	"./iPacers.png": "6c1f",
	"./iPelicans.png": "b15c",
	"./iPistons.png": "67a3",
	"./iRaptors.png": "91f0",
	"./iRockets.png": "6ba7",
	"./iSpurs.png": "4b06",
	"./iSuns.png": "c8c0",
	"./iThunder.png": "4416",
	"./iTimberwolves.png": "1308",
	"./iTrailBlazers.png": "4c80",
	"./iWarriors.png": "052d",
	"./iWizards.png": "40e6",
	"./isixers.png": "5092"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "426d";